import { Layout, Steps } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setStep } from '../../shared/store/onboardSlice';

import StartHere from './pages/StartHere';
import KnowledgeVerification from './pages/KnowledgeVerification';
import KnowledgeAnalysis from './pages/KnowledgeAnalysis';
import CreatingBot from './pages/CreatingBot';
import Complete from './pages/CompleteNew';
import styles from './onboard.module.scss';
import CustomAlert from '../../components/CustomAlert';

const Onboard = () => {
  const dispatch = useDispatch();
  const FaceBotCount = useSelector((state) => state.config.facebot_count);
  const current = useSelector(state => state.onboard.currentStep);
  const [IsAvatarId, setAvatarId] = useState('');
  const [kbName, setKbName] = useState('');
  const [kbDescription, setKbDescription] = useState('');
  const [kbLibrary, setKbLibrary] = useState();
  const [showResumeAlert, setShowResumeAlert] = useState(false);

  const StepItems = [
    { title: 'Start here', disabled: true },
    { title: 'Knowledge Analysis & sorting', disabled: true },
    { title: 'Knowledge verification', disabled: true },
    { title: 'Creating FaceBot', disabled: true },
    { title: 'Complete', disabled: true },
  ];


  // Show alert if user refreshes mid-onboarding
  // useEffect(() => {
  //   if (current !== 0 && FaceBotCount !== null) {
  //     console.log('Resuming onboarding...', current, FaceBotCount);
      
  //     setShowResumeAlert(true);
  //     setTimeout(() => setShowResumeAlert(false), 5000); // Auto-dismiss after 5s
  //   }
  // }, []);

  const onChange = (value) => {
    dispatch(setStep(value));
  };

  const renderStepContent = () => {
    switch (current) {
    case 0:
      return (
        <StartHere
          setCurrent={(step) => dispatch(setStep(step))}
          setKbName={setKbName}
          setKbDescription={setKbDescription}
          kbName={kbName}
          kbDescription={kbDescription}
        />
      );
    case 1:
      return (
        <KnowledgeAnalysis
          setCurrent={(step) => dispatch(setStep(step))}
          kbName={kbName}
          kbDescription={kbDescription}
          setKbDescription={setKbDescription}
        />
      );
    case 2:
      return <KnowledgeVerification setCurrent={(step) => dispatch(setStep(step))} setKbLibrary={setKbLibrary} />;
    case 3:
      return <CreatingBot setCurrent={(step) => dispatch(setStep(step))} setAvatarId={setAvatarId} kbLibrary={kbLibrary} />;
    case 4:
      return <Complete IsAvatarId={IsAvatarId} />;
    default:
      return <div>Unknown step</div>;
    }
  };

  return (
    <div className={styles.wrapper}>
      {showResumeAlert && (
        <CustomAlert messageText="Resuming onboarding. Continue from where you left off." />
      )}

      <Steps
        current={current}
        onChange={onChange}
        size="small"
        items={StepItems}
        style={{ paddingTop: 60, paddingInline: 90, paddingBottom: 25 }}
      />
      <Layout style={{ width: '100%', height: 'calc(100vh - 100px)', overflow: 'auto' }}>
        {renderStepContent()}
      </Layout>
    </div>
  );
};

export default Onboard;
